@if (!rows.length) {
    <p class="empty">None of these have any {{fieldName}} in a model.</p>
} @else {
    <p class="pareto-headline">
        <b>{{spread}} of {{rows.length}}</b> work in more than one model.
        @if (shown.length < rows.length) { The {{rows.length - shown.length}} smallest aren't shown. }
    </p>
    <div class="chart-legend" aria-label="What the shading means">
        <span class="legend-item">Less</span>
        <span class="heat-scale">
            @for (s of steps; track $index) { <span class="heat-step" [style.background]="shade(s)"></span> }
        </span>
        <span class="legend-item">More {{fieldName}}</span>
        <span class="legend-note">Shaded on a log scale. Click a name to select the node</span>
    </div>
    <div class="heatmap-scroll">
        <table class="heatmap" [attr.aria-label]="fieldName + ' by model'">
            <thead>
                <tr>
                    <th class="corner" scope="col"></th>
                    @for (c of columns; track c.key) { <th scope="col" [title]="c.name + ': ' + value(c.total, false)"><span>{{c.name}}</span></th> }
                    <th scope="col" class="total-head"><span>Total</span></th>
                </tr>
            </thead>
            <tbody>
                @for (r of shown; track r.key) {
                    <tr>
                        <th scope="row"><button type="button" class="row-name" (click)="select(r)" [title]="r.name">{{r.name}}</button></th>
                        @for (v of r.cells; track $index; let i = $index) {
                            <td [style.background]="shade(v)" [class.dark]="dark(v)" [title]="tip(r, i)">{{value(v)}}</td>
                        }
                        <td class="total">{{value(r.total)}}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
